import { render, staticRenderFns } from "./Mappings.vue?vue&type=template&id=32f04bf7&"
import script from "./Mappings.vue?vue&type=script&lang=js&"
export * from "./Mappings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Mappings.vue"
export default component.exports